// extracted by mini-css-extract-plugin
module.exports = {"SystemLink":"SystemLink_SystemLink__5GYD7"};